import * as React from 'react'

type PaddingSize = 'none' | 'sm' | 'md' | 'lg' | 'xl'

const paddingMap: Record<PaddingSize, string> = {
  none: '',
  sm: 'py-6',
  md: 'py-12',
  lg: 'py-20',
  xl: 'py-24',
}

export interface SectionProps {
  children: React.ReactNode
  padding?: PaddingSize
  background?: string
  className?: string
  id?: string
}

// A section paints its own visible background when `background` is set to
// anything other than an empty string or a `bg-white` class. In that case it
// earns generous vertical padding; otherwise it sits on the page background
// and uses a modest rhythm value. Callers can override with `padding`.
const hasVisibleBackground = (bg: string): boolean => {
  const trimmed = bg.trim()
  if (trimmed === '') return false
  return !trimmed.split(/\s+/).some((cls) => cls === 'bg-white')
}

export const Section: React.FC<SectionProps> = ({
  children,
  padding,
  background = '',
  className = '',
  id,
}) => {
  const resolvedPadding: PaddingSize =
    padding ?? (hasVisibleBackground(background) ? 'lg' : 'md')
  return (
    <section
      id={id}
      className={`${paddingMap[resolvedPadding]} ${background} ${className}`.trim()}
    >
      {children}
    </section>
  )
}
